module.exports = __webpack_public_path__ + "static/img/1.791a608.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-maquinaria-equipo-contratistas/1.png
// module id = 2usE
// module chunks = 0